import Map from './map.vue';

export default Map;
